import React from 'react';
import { useHistory } from 'react-router-dom';

const NotFoundPage = () => {
  const history = useHistory();

  const handleGoHome = () => {
    history.push('/');
  };

  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gray-100 relative overflow-hidden">
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <div className="roadblock w-full h-full relative">
          <div className="roadblock-bar"></div>
          <div className="roadblock-bar"></div>
          <div className="roadblock-bar"></div>
        </div>
      </div>
      <div className="relative z-10 text-center">
        <h1 className="text-4xl font-bold text-gray-800 mb-4">Oops! Page Not Found</h1>
        <p className="text-lg text-gray-600 mb-8">
          The page you are looking for does not exist. It might have been moved or deleted.
        </p>
        <button
          onClick={handleGoHome}
          className="px-6 py-3 bg-sky-500 text-white text-lg font-semibold rounded-md hover:bg-sky-600 transition duration-300"
        >
          Go to Home
        </button>
      </div>
    </div>
  );
};

export default NotFoundPage;
